import { render, staticRenderFns } from "./text-input-component.vue?vue&type=template&id=9155ab2a"
import script from "./text-input-component.vue?vue&type=script&lang=js"
export * from "./text-input-component.vue?vue&type=script&lang=js"
import style0 from "./text-input-component.vue?vue&type=style&index=0&id=9155ab2a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports